import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useDispatch } from "react-redux"
import handleRenderOption from "./handleRenderOption"
import { obtenerBusquedaAction } from "../../../ducks/cotizacioensDuck"
import { useSelector } from "react-redux"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { InitialValue } from "./InitialValue"
const CBCotizaciones = () => {
    const {listaCotizaciones} = useSelector(store => store.cotizaciones)
    const dispatch = useDispatch()
    const getOptionHangle = (event, valor) => {
        if (valor) {
            dispatch(onLoadAnction({message: "Buscando..."}))
            dispatch(obtenerBusquedaAction({ busqueda: valor })).then(Response => {
                dispatch(offLoadAction())
            })
        } else {
            dispatch(obtenerBusquedaAction({ busqueda: InitialValue }))
        }
    }
    return (
        <div>
            <Autocomplete
                id={`id-auto-Clientes`}
                options={listaCotizaciones.sort((a, b) => a.IdCotizacion > b.IdCotizacion)}
                getOptionLabel={(option) => {
                    let nombre = option?.Cliente?.Nombre 
                    return `${option?.IdCotizacion} - ${nombre} (${option?.Cliente?.EMail})`
                }}
                style={{
                    width: "100%",
                    margin: "5px 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={listaCotizaciones.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Clientes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="clientes"
                    />
                )}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default CBCotizaciones